import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { IAppConfig } from "../core/models/app-config.model";
import { AppConfig } from "../design/app";
import { IApiResponse } from "../core/models/api-response.model";
import { MasterData } from "../models/master-model";
  const urlsStartPoint = "";
  
  @Injectable()
  export class MasterDataService {
    savedCountryForManageMailBox: any;
    masterData: any;
    facilitatorInputs: any;
    securityInputs: any;
    additionalQuestionInputs: any;
    dataCleanUpInputs: any;
    assessmentInputs: any;
    appConfig: any;
    baseUrl;
    constructor(private http: HttpClient) {
      this.appConfig = AppConfig;
            this.baseUrl = this.appConfig.session.baseUrl;
    }
  
    public getMasterDataDetails(): Observable<any> {
      if (this.masterData) {
        return of(this.masterData);
      }
      const endpoint = this.appConfig.session.getMaterData;
        const apiUrl = `${this.baseUrl + endpoint}`;
      const headers = new HttpHeaders();
      return this.http.get<IApiResponse<MasterData>>(apiUrl+"?returnDeloittedata=true&IsIncludeNA=true", { headers: headers }).pipe(
        map((res) => {
          this.masterData = res.Data;
          return res.Data;
        }),
        catchError(this.handleError)
      );
    }
  
    private handleError(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        console.error("An error occurred:", error.error.message);
      } else {
        console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
        );
      }
      return throwError("Something bad happened; please try again later.");
    }
  
    set facilitatorData(data) {
      this.facilitatorInputs = data;
    }
  
    get facilitatorData() {
      return this.facilitatorInputs;
    }
  
    // Session Search
    public sessionSearchModelData: any;
  
    set sessionSearchData(data) {
      this.sessionSearchModelData = data;
    }
  
    get sessionSearchData() {
      return this.sessionSearchModelData;
    }
  
    // Subscription Search
    public subscriptionSearchData: any;
  
    set subsSearchData(data) {
      this.sessionSearchModelData = data;
    }
  
    get subsSearchData() {
      return this.sessionSearchModelData;
    }
  
    // for Security
    set securityData(data) {
      this.securityInputs = data;
    }
  
    get securityData() {
      return this.securityInputs;
    }
  
    set additionalQuestionData(data) {
      this.additionalQuestionInputs = data;
    }
  
    get additionalQuestionData() {
      return this.additionalQuestionInputs;
    }
  
    set dataCleanUpData(data) {
      this.dataCleanUpInputs = data;
    }
  
    get dataCleanUpData() {
      return this.dataCleanUpInputs;
    }
  
    set assessmentData(data) {
      this.assessmentInputs = data;
    }
  
    get assessmentData() {
      return this.assessmentInputs;
    }
  
    set countryForManageMailBox(data) {
      this.savedCountryForManageMailBox = data;
    }
  
    get countryForManageMailBox() {
      return this.savedCountryForManageMailBox;
    }
  
    // Email Search
    public searchEmailModelData: any;
  
    set emailSearchData(data) {
      this.sessionSearchModelData = data;
    }
  
    get emailSearchData() {
      return this.searchEmailModelData;
    }
  }
